import apiService from "./BaseApi";
import store from "@/store/index";

const ENDPOINT_WITHOUT_SECTOR_PATH = "modens/findAllWithoutSector";
const ENDPOINT_GENERATE_ID = "modens/generate-id";
const ENDPOINT_FIND_ALL = "modens/findAll";
const ENDPOINT_FIND_BY_FRANCHISEE = "modens/findByFranchisee";
const ENDPOINT_GET = "modens/get";
const ENDPOINT_LOCAL_REGISTER = "modens/register";
const ENDPOINT_INTERNAL_REGISTER = "modens/internal/register";
const ENDPOINT_LOCAL_UPDATE = "modens/update";
const ENDPOINT_LOCAL_DELETE = "modens/delete";
const ENDPOINT_LORAWAN_UPDATE = "modens/lorawan/update";
const ENDPOINT_LORAWAN_DELETE = "modens/lorawan/delete";
const ENDPOINT_NLT_REGISTER = "modens/nlt/register";
const ENDPOINT_PARLACOM_REGISTER = "modens/parlacom/register";

export const BROKER_SUPPLY = {
  NLT: "NLT",
  PARLACOM: "PARLACOM",
};

const currentUserPayload = () => ({
  currentUserId: store.state.currentUser?.uid,
});

const registerEndpointByBrokerSupply = (brokerSupply) => {
  switch (brokerSupply) {
    case BROKER_SUPPLY.NLT:
      return ENDPOINT_NLT_REGISTER;
    case BROKER_SUPPLY.PARLACOM:
      return ENDPOINT_PARLACOM_REGISTER;
    default:
      return null;
  }
};

const ModensService = {
  generateId: async () =>
    apiService.post(ENDPOINT_GENERATE_ID, currentUserPayload()),

  findAll: async () =>
    apiService.post(ENDPOINT_FIND_ALL, currentUserPayload()),

  findByFranchisee: async (idFranchisee) =>
    apiService.post(ENDPOINT_FIND_BY_FRANCHISEE, {
      ...currentUserPayload(),
      idFranchisee,
    }),

  getById: async (id) =>
    apiService.post(ENDPOINT_GET, {
      ...currentUserPayload(),
      id,
    }),

  findAllWithoutSector: async () =>
    apiService.post(ENDPOINT_WITHOUT_SECTOR_PATH, currentUserPayload()),

  /** POST modens/register — LTE/Wi-Fi local (somente Firestore, sem network server) */
  registerLocal: async (modemData) =>
    apiService.post(ENDPOINT_LOCAL_REGISTER, {
      ...currentUserPayload(),
      modem: modemData,
    }),

  /** POST modens/internal/register — LoRa Gateway com fornecedor interno */
  registerInternal: async (modemData) =>
    apiService.post(ENDPOINT_INTERNAL_REGISTER, {
      ...currentUserPayload(),
      modem: modemData,
    }),

  updateLocal: async (id, modem) =>
    apiService.post(ENDPOINT_LOCAL_UPDATE, {
      ...currentUserPayload(),
      id,
      modem,
    }),

  updateLorawan: async (id, modem) =>
    apiService.post(ENDPOINT_LORAWAN_UPDATE, {
      ...currentUserPayload(),
      id,
      modem,
    }),

  deleteLocal: async (id) =>
    apiService.post(ENDPOINT_LOCAL_DELETE, {
      ...currentUserPayload(),
      id,
    }),

  deleteLorawan: async (id) =>
    apiService.post(ENDPOINT_LORAWAN_DELETE, {
      ...currentUserPayload(),
      id,
    }),

  /** POST modens/nlt/register ou modens/parlacom/register conforme brokerSupply */
  registerLorawan: async (modemData) => {
    const endpoint = registerEndpointByBrokerSupply(modemData.brokerSupply);
    if (!endpoint) {
      return Promise.reject(new Error("invalid brokerSupply"));
    }
    return apiService.post(endpoint, {
      ...currentUserPayload(),
      ...modemData,
    });
  },
};

export default ModensService;
